import { render } from "./CookieDataPrivacyAlert.vue?vue&type=template&id=37cbc265"
import script from "./CookieDataPrivacyAlert.vue?vue&type=script&lang=js"
export * from "./CookieDataPrivacyAlert.vue?vue&type=script&lang=js"
script.render = render

export default script